import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';

import api from 'api';
import { RouteConstants } from 'containers/Survey/routes';
import { logScreen } from 'core/analytics';
import { UserForm } from '../components/UserDetail/UserForm';

import '../styles/styles.scss';

interface Props extends RouteComponentProps {}

interface State {
  submitting: boolean;
}

class Home extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }

  componentDidMount(): void {
    logScreen('ASSESSMENT_HOME');
  }

  submitFormHandler = async values => {
    this.setState({
      submitting: true,
    });

    try {
      const patient = await api.surveys.createSurveyPatient(values);
      const search = new URLSearchParams(this.props.location.search);
      search.set('patient', patient._id);
      this.props.history.push({
        pathname: RouteConstants.ASSESSMENT_SURVEY,
        search: search.toString(),
      });
    } catch (e) {
      console.error(e);
    }

    this.setState({
      submitting: false,
    });
  };

  render() {
    return (
      <div className="container assessment_home">
        <article className="intro">
          <h1 className="theme_title1">Sleep Assessment</h1>
        </article>
        <UserForm submitting={this.state.submitting} onSubmit={this.submitFormHandler} />
      </div>
    );
  }
}

export default Home;
